import i18next from 'i18next';

i18next.addResources('es', 'EvidenceStatus', {
  inProcess: 'En trámite',
  finalized: 'Finalizada'
});
